module.exports = __webpack_public_path__ + "public/Icons/lightModeOff.svg?c698f5cd";